export default [
    {
        name:"Gauge",
        icon:"fa-tachometer-alt",
        configInterface: [],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            let name=\"\"\n" +
            "            let value=0\n" +
            "            for (let seriesIndex in data) {\n" +
            "                if(seriesIndex===\"timestamp\"){\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    let seriesVal=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)\n" +
            "                    if (seriesVal!==null) {\n" +
            "                        value=Math.round(seriesVal*100)/100\n" +
            "                        name=seriesIndex\n" +
            "                        break;\n" +
            "                    }\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                series: [\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 15,\n" +
            "                        max: 35,\n" +
            "                        splitNumber: 5,\n" +
            "                        itemStyle: {\n" +
            "                            color: '#FFFFFF',\n" +
            "        shadowBlur: 5,        \n" +
            "          shadowColor: 'rgba(0,0,0,0.5)', \n" +
            "          shadowOffsetX: 3,      \n" +
            "          shadowOffsetY: 3 " +
            "                        },\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            overlap:false,\n" +
            "                            width: 15\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            lineStyle: {\n" +
            "                                width: 30,\n" +
            "                                color:[[0.4, '#58d9f9'],\n" +
            "                                    [0.6, '#7cffb2'],\n" +
            "                                    [1, '#ff9f7f']]\n" +
            "                            }\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            distance: -45,\n" +
            "                            splitNumber: 5,\n" +
            "                            lineStyle: {\n" +
            "                                width: 2,\n" +
            "                                color: '#FFFFFF'\n" +
            "                            }\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            distance: -52,\n" +
            "                            length: 14,\n" +
            "                            lineStyle: {\n" +
            "                                width: 3,\n" +
            "                                color: '#FFFFFF'\n" +
            "                            }\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            distance: -5,\n" +
            "                            color: 'inherit',\n" +
            "                            fontSize: 12\n" +
            "                        },\n" +
            "                        anchor: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        title: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            valueAnimation: true,\n" +
            "                            width: '60%',\n" +
            "                            lineHeight: 40,\n" +
            "                            borderRadius: 8,\n" +
            "                            offsetCenter: [0, '-15%'],\n" +
            "                            fontSize: 45,\n" +
            "                            fontWeight: 'bolder',\n" +
            "                            formatter: '{value}',\n" +
            "                            color: 'inherit'\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {value:0, detail: {show:false}},\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                            },\n" +
            "                        ]\n" +
            "                    },\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        title:{\n" +
            "                            color: '#FFFFFF'\n" +
            "                        },\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 40,\n" +
            "                        max: 50,\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            width: 8\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                                name:name\n" +
            "                            }\n" +
            "                        ]\n" +
            "                    }\n" +
            "                ]\n" +
            "            }\n" +
            "        }"
    },{
        name:"Indicator",
        icon:"fa-tachometer-alt",
        configInterface: [
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            let name=\"\"\n" +
            "            let value=0\n" +
            "            for (let seriesIndex in data) {\n" +
            "                if(seriesIndex===\"timestamp\"){\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    let seriesVal=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)\n" +
            "                    if (seriesVal!==null) {\n" +
            "                        value=Math.round(seriesVal*100)/100\n" +
            "                        name=seriesIndex\n" +
            "                        break;\n" +
            "                    }\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                \n" +
            "                title:{\n" +
            "                        text: name,\n" +
            "                        color: '#FFFFFF',\n" +
            "                        top:'30%',\n" +
            "                        left: 'center',\n" +
            "                        textStyle: {\n" +
            "                            width: 300,\n" +
            "                            fontSize: 25,\n" +
            "                            lineHeight: 30,\n" +
            "                            fontFamily: \"Roboto, Arial, sans-serif\"\n" +
            "                        }\n" +
            "                    },\n" +
            "                    \n" +
            "                series: [\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        radius:'0%',\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 15,\n" +
            "                        max: 35,\n" +
            "                        splitNumber: 5,\n" +
            "                        itemStyle: {\n" +
            "                            color: '#FFFFFF'\n" +
            "                        },\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            overlap:false,\n" +
            "                            width: 15\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            lineStyle: {\n" +
            "                                width: 30,\n" +
            "                                color:[[0.4, '#1f77b4'],\n" +
            "                                    [0.6, '#2ca02c'],\n" +
            "                                    [1, '#ff7f0e']]\n" +
            "                            }\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        anchor: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        title: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            valueAnimation: true,\n" +
            "                            width: '60%',\n" +
            "                            lineHeight: 40,\n" +
            "                            borderRadius: 8,\n" +
            "                            offsetCenter: [0, '-15%'],\n" +
            "                            fontSize: 60,\n" +
            "                            fontWeight: 'bolder',\n" +
            "                            formatter: '{value}',\n" +
            "                            color: 'inherit'\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {value:0, detail: {show:false}},\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                            },\n" +
            "                        ]\n" +
            "                    },\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        radius:'0%',\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 40,\n" +
            "                        max: 50,\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            width: 8\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                            }\n" +
            "                        ]\n" +
            "                    }\n" +
            "                ]\n" +
            "            }\n" +
            "        }"
    },{
        name:"Value Box",
        icon:"fa-square",
        configInterface: [
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            let name=\"\"\n" +
            "            let value=0\n" +
            "            for (let seriesIndex in data) {\n" +
            "                if(seriesIndex===\"timestamp\"){\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    let seriesVal=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)\n" +
            "                    if (seriesVal!==null) {\n" +
            "                        value=Math.round(seriesVal*100)/100\n" +
            "                        name=seriesIndex\n" +
            "                        break;\n" +
            "                    }\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                grid:{\n" +
            "                     backgroundColor:'#1f77b4',\n" +
            "                      show:true,\n" +
            "                     top:20,\n" +
            "                     left:20,\n" +
            "                     right:20,\n" +
            "                     bottom:20,\n" +
            "                     shadowColor: 'rgba(0, 0, 0, 0.5)',\n" +
            "                     borderColor :null,\n" +
            "    shadowBlur: 10\n" +
            "                },\n" +
            "                title:{\n" +
            "                        text: name,\n" +
            "                        color: '#FFFFFF',\n" +
            "                        top:'30%',\n" +
            "                        left: 'center',\n" +
            "                        textStyle: {\n" +
            "                            width: 300,\n" +
            "                            fontSize: 25,\n" +
            "                            lineHeight: 30,\n" +
            "                            fontFamily: \"Roboto, Arial, sans-serif\"\n" +
            "                        }\n" +
            "                    },\n" +
            "                    \n" +
            "                series: [\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        radius:'0%',\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 15,\n" +
            "                        max: 35,\n" +
            "                        splitNumber: 5,\n" +
            "                        itemStyle: {\n" +
            "                            color: '#FFFFFF'\n" +
            "                        },\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            overlap:false,\n" +
            "                            width: 15\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            lineStyle: {\n" +
            "                                width: 30,\n" +
            "                                color:[[0.4, '#1f77b4'],\n" +
            "                                    [0.6, '#2ca02c'],\n" +
            "                                    [1, '#ff7f0e']]\n" +
            "                            }\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            show:false\n" +
            "                        },\n" +
            "                        anchor: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        title: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            valueAnimation: true,\n" +
            "                            width: '60%',\n" +
            "                            lineHeight: 40,\n" +
            "                            borderRadius: 8,\n" +
            "                            offsetCenter: [0, '-15%'],\n" +
            "                            fontSize: 60,\n" +
            "                            fontWeight: 'bolder',\n" +
            "                            formatter: '{value}',\n" +
            "                            color: 'inherit',\n" +
            "                             formatter: function (value) {\n" +
            "          return '' + value.toFixed(2) + ''; //unit here\n" +
            "        },\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {value:0, detail: {show:false}},\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                            },\n" +
            "                        ]\n" +
            "                    },\n" +
            "                    {\n" +
            "                        type: 'gauge',\n" +
            "                        radius:'0%',\n" +
            "                        center: ['50%', '60%'],\n" +
            "                        startAngle: 200,\n" +
            "                        endAngle: -20,\n" +
            "                        min: 40,\n" +
            "                        max: 50,\n" +
            "                        progress: {\n" +
            "                            show: true,\n" +
            "                            width: 8\n" +
            "                        },\n" +
            "                        pointer: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisTick: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        splitLine: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        axisLabel: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        detail: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        data: [\n" +
            "                            {\n" +
            "                                value: value,\n" +
            "                            }\n" +
            "                        ]\n" +
            "                    }\n" +
            "                ]\n" +
            "            }\n" +
            "        }"
    },
    {
        name:"Pie",
        icon:"fa-chart-pie",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            let chartSeries=[]\n" +
            "            for (let seriesIndex in data) {\n" +
            "                if(seriesIndex===\"timestamp\"){\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    let value=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)\n" +
            "                    if (value>0){\n" +
            "                        chartSeries.push({ value: Math.round(value*100)/100, name: seriesIndex.split(\" - \")[0] })\n" +
            "                    }\n" +
            "                }\n" +
            "\n" +
            "            }\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                label: {\n" +
            "                    alignTo: 'edge',\n" +
            "                    formatter:'{name|{b}}\\n{number|{c}} ({percentage|{d} %})',\n" +
            "                    minMargin: 5,\n" +
            "                    edgeDistance: 10,\n" +
            "                    lineHeight: 18,\n" +
            "                    fontSize:14,\n" +
            "                    color:\"#FFFFFF\",\n" +
            "                    rich: {\n" +
            "                        name:{\n" +
            "                            fontWeight:550,\n" +
            "                            fontSize:15\n" +
            "                        },\n" +
            "                        percentage:{\n" +
            "                            fontWeight:550,\n" +
            "                            fontSize:14\n" +
            "                        }\n" +
            "                    }\n" +
            "                },\n" +
            "                labelLine: {\n" +
            "                    length: 15,\n" +
            "                    length2: 0,\n" +
            "                    maxSurfaceAngle: 80\n" +
            "                },\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                tooltip: {\n" +
            "                    trigger: 'item'\n" +
            "                },\n" +
            "                legend: {\n" +
            "                    show: false\n" +
            "                },\n" +
            "                series: [\n" +
            "                    { type: 'pie', radius: ['44%', '62%'], silent: true, label: { show: false }, data: [ { value: 1, itemStyle: { color: 'rgba(30,30,30,0.2)' } } ] },{\n" +
            "                        type: 'pie',\n" +
            "                        radius: ['47%', '59%'],\n" +
            "                        avoidLabelOverlap: true,\n" +
            "                        itemStyle: {\n" +
            "                            borderRadius: 10,\n" +
            "                        },\n" +
            "                        data: chartSeries,\n" +
            "                    }\n" +
            "                ],\n" +
            "            }\n" +
            "        }"
    },{
        name:"Stacked Bar",
        icon:"fa-chart-bar",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
            {
                "type":"string",
                "name": "xName",
                "label":"X Label"
            },
            {
                "type":"string",
                "name": "yName",
                "label":"Y Label"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            var chartSeries = [];\n" +
            "            for (var seriesIndex in data) {\n" +
            "                if (seriesIndex === \"timestamp\") {\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    chartSeries.push({\n" +
            "                        data:data[seriesIndex],\n" +
            "                        name: seriesIndex,\n" +
            "                        type: 'bar',\n" +
            "                        stack: 'total',\n" +
            "                        label: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        emphasis: {\n" +
            "                            focus: 'series'\n" +
            "                        },\n" +
            "                    });\n" +
            "\n" +
            "                }\n" +
            "            }\n" +
            "\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                tooltip: {\n" +
            "                    trigger: 'axis',\n" +
            "                    axisPointer: {\n" +
            "                        type: 'shadow'\n" +
            "                    }\n" +
            "                },\n" +
            "                legend: {\n" +
            "                    top: 'bottom'\n" +
            "                },\n" +
            "\n" +
            "                yAxis: {\n" +
            "                    type: 'value',\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['yName']" +
            "                },\n" +
            "                xAxis: {\n" +
            "                    data: data.timestamp,\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['xName']" +
            "                },\n" +
            "                series:chartSeries\n" +
            "            };\n" +
            "        }"
    },{
        name:"Grouped Bar",
        icon:"fa-chart-bar",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
            {
                "type":"string",
                "name": "xName",
                "label":"X Label"
            },
            {
                "type":"string",
                "name": "yName",
                "label":"Y Label"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            var chartSeries = [];\n" +
            "            for (var seriesIndex in data) {\n" +
            "                if (seriesIndex === \"timestamp\") {\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    chartSeries.push({\n" +
            "                        data:data[seriesIndex],\n" +
            "                        name: seriesIndex,\n" +
            "                        type: 'bar',\n" +
            "                        label: {\n" +
            "                            show: false\n" +
            "                        },\n" +
            "                        emphasis: {\n" +
            "                            focus: 'series'\n" +
            "                        },\n" +
            "                    });\n" +
            "\n" +
            "                }\n" +
            "            }\n" +
            "\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                tooltip: {\n" +
            "                    trigger: 'axis',\n" +
            "                    axisPointer: {\n" +
            "                        type: 'shadow'\n" +
            "                    }\n" +
            "                },\n" +
            "                legend: {\n" +
            "                    top: 'bottom'\n" +
            "                },\n" +
            "\n" +
            "                yAxis: {\n" +
            "                    type: 'value',\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['yName']" +
            "                },\n" +
            "                xAxis: {\n" +
            "                    data: data.timestamp,\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['xName']" +
            "                },\n" +
            "                series:chartSeries\n" +
            "            };\n" +
            "        }"
    },{
        name:"Stacked Area",
        icon:"fa-chart-area",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
            {
                "type":"string",
                "name": "xName",
                "label":"X Label"
            },
            {
                "type":"string",
                "name": "yName",
                "label":"Y Label"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            var chartSeries = [];\n" +
            "\n" +
            "            for (var seriesIndex in data) {\n" +
            "                if (seriesIndex === \"timestamp\") {\n" +
            "                    continue;\n" +
            "                } else {\n" +
            "                    chartSeries.push({\n" +
            "                        data:data[seriesIndex],\n" +
            "                        name: seriesIndex,\n" +
            "                        type: 'line',\n" +
            "                        stack: 'Total',\n" +
            "                        areaStyle: {},\n" +
            "                        emphasis: {\n" +
            "                            focus: 'series'\n" +
            "                        },});\n" +
            "\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                tooltip: {\n" +
            "                    trigger: 'axis',\n" +
            "                    axisPointer: {\n" +
            "                        type: 'cross',\n" +
            "                        label: {\n" +
            "                            backgroundColor: '#6a7985'\n" +
            "                        }\n" +
            "                    }\n" +
            "                },\n" +
            "                legend: {top: 'bottom'},\n" +
            "                yAxis: {\n" +
            "                    type: 'value',\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['yName']" +
            "                },\n" +
            "                xAxis: {\n" +
            "                    data: data.timestamp,\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['xName']" +
            "                },\n" +
            "                series:chartSeries\n" +
            "            };\n" +
            "        }"
    },{
        name:"X/nY",
        icon:"",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
            {
                "type":"string",
                "name": "xName",
                "label":"X Label"
            },
            {
                "type":"string",
                "name": "yName",
                "label":"Y Label"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            var chartSeries = [];\n" +
            "            var xValues=null;\n" +
            "\n" +
            "            for (var seriesIndex in data) {\n" +
            "                if (seriesIndex === \"timestamp\") {\n" +
            "                    continue;\n" +
            "                } else if (!xValues){\n" +
            "                    xValues=data[seriesIndex]\n" +
            "                } else { \n" +
            "                    chartSeries.push({\n" +
            "                        data:data[seriesIndex],\n" +
            "                        name: seriesIndex,\n" +
            "                        type: 'scatter',\n" +
            "                        symbolSize: 5,\n" +
            "                        });\n" +
            "\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                tooltip: {\n" +
            "                    trigger: 'axis',\n" +
            "                    axisPointer: {\n" +
            "                        type: 'cross',\n" +
            "                        label: {\n" +
            "                            backgroundColor: '#6a7985'\n" +
            "                        }\n" +
            "                    }\n" +
            "                },\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                legend: {top: 'bottom'},\n" +
            "                yAxis: {\n" +
            "                    type: 'value',\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['yName']" +
            "                },\n" +
            "                xAxis: {\n" +
            "                    type: 'value',\n" +
            "                    data: xValues,\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['xName']" +
            "                },\n" +
            "                series:chartSeries\n" +
            "            };\n" +
            "        }"
    },{
        name:"X/C/nY",
        icon:"",
        configInterface: [
            {
                "type":"string",
                "name": "title",
                "label":"Title"
            },
            {
                "type":"string",
                "name": "xName",
                "label":"X Label"
            },
            {
                "type":"string",
                "name": "yName",
                "label":"Y Label"
            },
        ],
        processorFunction:"(data,echarts,chartColorways, settings)=>{\n" +
            "            var chartSeries = [];\n" +
            "            var xValues=null;\n" +
            "            var cValues=null;\n" +
            "\n" +
            "            for (var seriesIndex in data) {\n" +
            "                if (seriesIndex === \"timestamp\") {\n" +
            "                    continue;\n" +
            "                } else if (!xValues){\n" +
            "                    xValues=data[seriesIndex]\n" +
            "                } else if (!cValues){\n" +
            "                    cValues=data[seriesIndex]\n" +
            "                }  else { \n" +
            "                    chartSeries.push({\n" +
            "                        data:data[seriesIndex],\n" +
            "                        name: seriesIndex,\n" +
            "                        type: 'scatter',\n" +
            "                        symbolSize: 5,\n" +
            "                        });\n" +
            "\n" +
            "                }\n" +
            "            }\n" +
            "            return {\n" +
            "                color: chartColorways[settings['colorway']],\n" +
            "                title: {\n" +
            "                    text: settings['title'],\n" +
            "                    left: 'center',\n" +
            "                    textStyle: {\n" +
            "                        fontSize:16,\n" +
            "                        fontWeight:500,\n" +
            "                        color:\"#FFFFFF\"\n" +
            "                    }\n" +
            "\n" +
            "                },\n" +
            "                tooltip: {\n" +
            "                    trigger: 'axis',\n" +
            "                    axisPointer: {\n" +
            "                        type: 'cross',\n" +
            "                        label: {\n" +
            "                            backgroundColor: '#6a7985'\n" +
            "                        }\n" +
            "                    }\n" +
            "                },\n" +
            "                legend: {top: 'bottom'},\n" +
            "                visualMap: {\n" +
            "                     data:cValues,\n" +
            "                     min:Math.min(...cValues),\n" +
            "                     max:Math.max(...cValues),\n" +
            "                        orient: 'vertical',\n" +
            "                        right: 10,\n" +
            "                        top: 'center',\n" +
            "                        text: [''],\n" +
            "                        calculable: true,\n" +
            "                        inRange: {\n" +
            "                          color: [ '#440154', '#482878', '#3e4989', '#31688e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825']\n" +
            "                        },\n" +
            "                        textStyle:{color: \"rgba(255, 255, 255, 1)\" },\n" +
            "                },\n" +
            "                yAxis: {\n" +
            "                    type: 'value',\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['yName']" +
            "                },\n" +
            "                xAxis: {\n" +
            "                    type: 'value',\n" +
            "                    data: xValues,\n splitLine: {show: true, lineStyle: {color: 'rgba(204, 204, 204, 0.1)'}},name:settings['xName']" +
            "                },\n" +
            "                series:chartSeries\n" +
            "            };\n" +
            "        }"
    },
]